import { Component, inject, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { LicenseFacade } from '@app/store/license';
import { EntityListComponent, UnavailableComponent } from '@shared/components';

@Component({
    selector: 'app-license-view-modal',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.css'],
    imports: [DatePipe, TranslateModule, ButtonModule, TagModule, EntityListComponent, UnavailableComponent],
})
export class ViewComponent implements OnDestroy {
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly licenseFacade = inject(LicenseFacade);

    readonly license = this.licenseFacade.license;
    readonly loading = this.licenseFacade.loading;
    readonly error = this.licenseFacade.error;

    constructor() {
        const id = this.route.parent?.snapshot.params['id'];
        if (id) {
            this.licenseFacade.getLicense(id);
        }
    }

    ngOnDestroy(): void {
        this.licenseFacade.clear();
    }

    onEdit(id: string): void {
        this.router.navigate([{ outlets: { modal: ['licenses', 'edit', id] } }]);
    }

    close(): void {
        this.router.navigate([{ outlets: { modal: null } }]);
    }
}
